// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__m8FRl","productName":"Table_productName__1bMIP"};